import type React from 'react';

export interface GraftsIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const GraftsIcon: React.FC<GraftsIconProps> = ({
	width = 16,
	height = 18,
	color = 'currentColor',
	'aria-label': ariaLabel = 'Grafts Icon',
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 16 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		aria-label={ariaLabel}
		style={{ color }}
	>
		<path
			d="M7.24307 8.99991V10.0681H6.29838C6.10944 10.0681 5.98348 10.2106 5.98348 10.4242C5.98348 10.6378 6.10944 10.7803 6.29838 10.7803H7.24307V11.8485C7.24307 12.0621 7.36903 12.2046 7.55797 12.2046C7.74691 12.2046 7.87287 12.0621 7.87287 11.8485V10.7803H8.81756C9.0065 10.7803 9.13246 10.6378 9.13246 10.4242C9.13246 10.2106 9.0065 10.0681 8.81756 10.0681H7.87287V8.99991C7.87287 8.78627 7.74691 8.64384 7.55797 8.64384C7.36903 8.64384 7.24307 8.78627 7.24307 8.99991ZM13.73 8.00291L7.74691 2.02088C7.62095 1.87846 7.43201 1.87846 7.30605 2.02088L1.32299 8.00291C1.19703 8.14534 1.19703 8.35898 1.32299 8.50141C1.44894 8.64384 1.63788 8.64384 1.76384 8.50141L2.5196 7.78926V15.7653C2.5196 15.9789 2.64556 16.1214 2.8345 16.1214H12.2814C12.4704 16.1214 12.5963 15.9789 12.5963 15.7653V7.78926L13.3521 8.50141C13.4151 8.57262 13.4781 8.57262 13.541 8.57262C13.604 8.57262 13.73 8.50141 13.793 8.43019C13.9189 8.35898 13.8559 8.07412 13.73 8.00291ZM11.9665 15.4092H3.14939V7.14833L7.55797 2.73303L11.9665 7.14833V15.4092Z"
			fill="currentColor"
		/>
	</svg>
);

export default GraftsIcon;
